import axios from '../utils/axios';

export default function fetchJobRefreshHistory(adminId, params) {
    return (
        axios.get('/admin/' + adminId + '/job-refresh-details', {
            params: params
        })
            .then(res => {
                return res.data
            })
            .catch(err => {
                return err;
            })
    )
}
